import { backStepByPath } from "../../../utils/updateStepBack";
import { getStepNavigation } from "../../../utils/nextBackStep";
import { useLocation } from "react-router-dom";
import { useGetInformationSteps } from "ah_utility/workflow";
import React from "react";
var useUI = function (navigate, setAccountType, setAccountNumber, setAccountName, setCardSelected) {
    var pathname = useLocation().pathname;
    useGetInformationSteps(pathname);
    var dataNavigation = React.useState(getStepNavigation(pathname))[0];
    var clickCard = function (item) {
        setAccountType(item.cardValues[0]);
        setAccountNumber(item.cardValues[1]);
        setAccountName(item.cardValues[2]);
        setCardSelected(true);
    };
    var handlePrevious = function () {
        backStepByPath(pathname);
        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.back));
    };
    return {
        clickCard: clickCard,
        handlePrevious: handlePrevious,
    };
};
export default useUI;
